<template>
    <v-bottom-sheet v-model="sheet" content-class="rounded-t-lg">
        <!-- card -->
        <v-card class="rounded-t-lg">
            <!-- title -->
            <v-toolbar flat class="text-h6 text-uppercase">
                <v-spacer/>
                {{$t('Profile.salary-details')}}
                <v-spacer/>
            </v-toolbar>

            <v-card-text class="px-9 pb-1">
                <!-- Received Salary -->
                <div class="mb-2">
                    <div class="d-flex justify-space-between align-center">
                        <span class="text-capitalize grey--text text--darken-3 text-body-1 font-weight-bold">
                            {{$t('Profile.received-salary')}}
                        </span>
                        <span class="text-body-1 secondary--text">{{ salary.finalTotal || 0 }}</span>
                    </div>
                </div>

                <!-- Received Salary -->
                <div>
                    <div class="d-flex justify-space-between align-center">
                        <span class="text-capitalize grey--text text--darken-3 text-body-1 font-weight-bold">
                            {{$t('Profile.receiving-date')}}
                        </span>
                        <span class="text-body-1">{{ moment(salary.date) || 0 }}</span>
                    </div>
                </div>

                <v-divider class="my-4"/>

                <!-- Base Salary -->
                <div class="mb-2">
                    <div class="d-flex justify-space-between align-center">
                        <span class="text-capitalize grey--text text--darken-3 text-body-1">
                            {{$t('Profile.base-salary')}}
                        </span>
                        <span class="text-body-1">{{ salary.baseSalary || 0 }}</span>
                    </div>
                </div>

                <!-- rewards -->
                <div class="mb-2">
                    <div class="d-flex justify-space-between align-center">
                        <span class="text-capitalize grey--text text--darken-3 text-body-1">
                            {{$t('Profile.rewards')}}
                        </span>
                        <span class="text-body-1">{{ salary.rewards || 0 }}</span>
                    </div>
                </div>

                <!-- rebates -->
                <div class="mb-2">
                    <div class="d-flex justify-space-between align-center">
                        <span class="text-capitalize grey--text text--darken-3 text-body-1">
                            {{$t('Profile.rebates')}}
                        </span>
                        <span class="text-body-1">{{ salary.rebates || 0 }}</span>
                    </div>
                </div>

                <!-- transportation -->
                <div class="mb-2">
                    <div class="d-flex justify-space-between align-center">
                        <span class="text-capitalize grey--text text--darken-3 text-body-1">
                            {{$t('Profile.transportation')}}
                        </span>
                        <span class="text-body-1">{{ salary.transportation || 0 }}</span>
                    </div>
                </div>

                <!-- liability compensation -->
                <div class="mb-2">
                    <div class="d-flex justify-space-between align-center">
                        <span class="text-capitalize grey--text text--darken-3 text-body-1">
                            {{$t('Profile.liability-compensation')}}
                        </span>
                        <span class="text-body-1">{{ salary.liabilityCompensation || 0 }}</span>
                    </div>
                </div>

                <!-- living expenses -->
                <div class="mb-2">
                    <div class="d-flex justify-space-between align-center">
                        <span class="text-capitalize grey--text text--darken-3 text-body-1">
                            {{$t('Profile.living-expenses')}}
                        </span>
                        <span class="text-body-1">{{ salary.livingExpenses || 0 }}</span>
                    </div>
                </div>

                <!-- communications -->
                <div class="mb-2">
                    <div class="d-flex justify-space-between align-center">
                        <span class="text-capitalize grey--text text--darken-3 text-body-1">
                            {{$t('Profile.communications')}}
                        </span>
                        <span class="text-body-1">{{ salary.communications || 0 }}</span>
                    </div>
                </div>

            </v-card-text>
            
            <v-card-actions class="pt-0">
                <v-spacer/>
                <v-btn
                    text
                    block
                    @click="sheet = false"
                    class="font-weight-bold"
                    color="grey darken-2"
                >
                    {{$T('done')}}
                </v-btn>
                <v-spacer/>
            </v-card-actions>
        </v-card>
    </v-bottom-sheet>
</template>

<script>
export default {
	props: ['salary'],

	data() {
		return {
			sheet: false
		}
	},

	methods: {
		activeSheet() {
			this.sheet = true;
		},

		moment(date) {
			return window.moment(date).format('YYYY-MM-DD');
		}
	}
}
</script>

<style>

</style>